webpackJsonp([205964721880533],{

/***/ 1544:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"RelationshipInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"name","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-relationship-input-ab7905fb1c1dff619683.js